<template>
  <div class='dataList'>
    <div class="list-wrap">
      <!-- 1是查采购商 -->
      <template v-if="datalist.dataType == 1">
        <ChartContent v-if="Object.keys(datalist.chartdata).length" :data="{ option: datalist.chartdata }" style="height: 300px;"></ChartContent>
        <div class="list-item" v-for="(item, index) in datalist.tabledata.result" :key="index">
          <span class="index">{{ index + 1 }}、</span>
          <span class="clickCompany" @click="clickCompany(item.id)">{{ item.name }}</span>
        </div>
      </template>
      <!-- 2/3是供应商/交易记录 4是统计数据-->
      <template v-else>
        <ChartContent v-if="[2, 4].includes(datalist.dataType) && Object.keys(datalist.chartdata).length" :data="{ option: datalist.chartdata } " style="height: 300px;"></ChartContent>
        <main-table
          v-if="[2, 3, 5].includes(datalist.dataType)"
          class="mainTable"
          :data="datalist.tabledata"
          :show-page="false"
          :show-search="false"
          :show-page-size="false"
          :tableCss="1"
          >
          <template v-slot:name="scope">
            <el-link :underline="false" type="primary" @click="clickCompany(scope.row.id)">{{ scope.row.name }}</el-link>
          </template>
          <template v-slot:supplierName="scope">
            <span class="companyNameLink">
              <a v-track="{triggerType: 'click'}" :href="`${localhost}/company/detail/${scope.row.supplierId}/0?wlf=ai_gpt`" class="aclss" target="_blank">{{ scope.row.supplierName }}</a>
            </span>
          </template>
          <template v-slot:buyerName="scope">
            <span class="companyNameLink">
              <a v-track="{triggerType: 'click'}" :href="`${localhost}/company/detail/${scope.row.buyerId}/0?wlf=ai_gpt`" class="aclss" target="_blank">{{ scope.row.buyerName }}</a>
            </span>
          </template>
          <template v-slot:productDesc="scope">
            <el-tooltip class="row-nowrap" effect="dark" placement="top-start" popper-class="trade_tooltip" :disabled="is_overflow(`productDesc_${scope.$index}`)">
              <div slot="content" v-html="formatHtml(scope.row.productDesc)"></div>
              <span v-html="formatHtml(scope.row.productDesc)" :id="'productDesc_'+scope.$index"></span>
            </el-tooltip>
          </template>
        </main-table>
      </template>
      <el-dropdown v-if="[1, 2].includes(datalist.dataType)" split-button type="primary" trigger="click" class="checkMore" @command="checkMore" @click="checkList">
       {{ $i18.language("查看企业列表") }}
        <el-dropdown-menu slot="dropdown" class="dropdown-menu" :append-to-body="false">
          <el-dropdown-item >{{ $i18.language("查看类似企业") }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button v-if="datalist.dataType == 3" plain @click="checkMore">{{ $i18.language("查看更多") }}</el-button>
      <el-button v-if="datalist.dataType == 1" plain @click="newSmartBusinessList">{{ $i18.language("创建商机列表") }}</el-button>
      <el-button v-if="datalist.dataType == 5" plain @click="gotoTrade">{{ $i18.language("查看详情") }}</el-button>
    </div>
    <smartBusisnessDialog v-if="smartBusisnessVisible" ref="smartBusisnessDialog" @closeBusisness="closeBusisness"></smartBusisnessDialog>
  </div>
</template>

<script>
import smartBusisnessDialog from '../../Company/components/result/smartBusisnessDialog';
import ChartContent from './chartContent.vue'

export default {
  components: {
    smartBusisnessDialog,
    ChartContent
  },
  props: {
    datalist: {
      type: Object,
      default: ()=>{return {}}
    }
  },
  data() {
    return {
      smartBusisnessVisible: false,
      localhost: this.$util.getCurrentWebSiteByProduct(),
      params: {},
      chartDatas: {
        animation: true,
        xAxis: {
          data: ["日本", "美国", "英国", "俄罗斯", "比利时"],
          type: 'category'
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          show: true,
        },
        grid: {
          bottom: 10,
          left: 0,
          right: 0,
          containLabel: true,
        },
        series: [
          {
            type: 'line',
            data: [2047037.3, 1672503.35, 581857.33, 502110.64, 397137.96],
            areaStyle: {
              color: 'rgba(255, 199, 46, 0.2)'
            },
            lineStyle: {
              width: 1.5
            },
            itemStyle: {
              color: 'rgba(255, 199, 46, 1)',
              opacity: 0
            }
          }
        ]
      },
      chartDataBar: {
        color: ['#86BDFF'],
        title: {
          text: "2023年中国智能手机出口主要国家",
          left: 'center'
        },
        tooltip: {
          show: true
        },
        grid: {
          left: '1%',
          right: '1%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: ["美国", "中国香港", "日本", "荷兰", "捷克"]
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          type: "bar",
          data: [
            {value: 30139843743.85, itemStyle: {color: "#5470c6"}},
            {value: 24939813434.19, itemStyle: {color: "#91cc75"}},
            {value: 6717106717.23, itemStyle: {color: "#fac858"}},
            {value: 4439341425.63, itemStyle: {color: "#ee6666"}},
            {value: 3699772585.79, itemStyle: {color: "#73c0de"}}
                ]
        }]
      },
      chartDatasPie: {
        title: {
          text: "美国主要进口中国鞋类产品的公司",
          left: 'center'
        },
        tooltip: {
          formatter: '{b} : {c} ({d}%)'
        },
        color:['#EA5519', '#0070F2', '#2B9FB6', '#FDB32F', '#F62866', '#1B90FF', '#18B6B1', '#FFDF92', '#FF7070', '#6AB0F4', '#D3D3D3'],
        series: [{
          type: "pie",
          center: ['50%', '55%'],
          radius: ['40%', '65%'],
          label: {
            show: true,
            formatter: '{b}：{d}%',
            color: '#1D2D3E'
          },
          data: [
            { value: 522067698.65, name: "Brazil", itemStyle: {color: "#5470c6"} },
            { value: 58310431.05, name: "Hong Kong", itemStyle: {color: "#91cc75"} },
            { value: 50224671.84, name: "New Zealand", itemStyle: {color: "#fac858"} },
            { value: 84012349.70, name: "Thailand", itemStyle: {color: "#ee6666"} },
            { value: 714615151.24, name: "Total", itemStyle: {color: "#73c0de"} }
          ]
        }],
      }
    };
  },
  methods: {
    is_overflow(id) {
      return document.getElementById(id) && document.getElementById(id).offsetHeight < document.getElementById(id).scrollHeight
    },
    // 标准化字符串，当单行或双行展示时，替换掉字符串中的换行标签；自定义展示时完全展示
    formatHtml(str) {
      let value = str
      if(typeof(str) == 'string') {
        value = str.replaceAll('<BR>', ' ')
      }
      return value
    },
    clickCompany(val){
      window.open(this.localhost + `/company/detail/${val}/0?wlf=ai_gpt`)
    },
    checkList() {
      let tradeType= `tabCheck=${this.datalist.moreType}&uniqueKey=${this.datalist.uniqueKey}`
      window.open(`${this.localhost}/trade/result?${tradeType}&wlf=ai_gpt`)
    },
    checkMore(){
      let tradeType= `tabCheck=${this.datalist.moreType}&uniqueKey=${this.datalist.uniqueKey}`
      let companyType = `tabCheck=${this.datalist.moreType}&where=businessDetail&uniqueKey=${this.datalist.uniqueKey}`
      if (this.datalist.dataType == 1 || this.datalist.dataType == 2) {
        window.open(`${this.localhost}/company/result?${companyType}&wlf=ai_gpt`)
      } else if (this.datalist.dataType == 3) {
        window.open(`${this.localhost}/trade/result?${tradeType}&wlf=ai_gpt`)
      }
    },
    newSmartBusinessList(){
      this.smartBusisnessVisible = true
      this.fromAIGPT(this.datalist.uniqueKey)
    },
    fromAIGPT(uniqueKey) {
      this.$api.ai.getGptSessionMsgRequestData({uniqueKey}).then(res => {
        if (res.code == 200) {
          let {countryIds, hsCods, productDescriptions, importerCompanyNames, exporterCompanyNames, destinationCountryIds, originCountryIds, importCompanyCountryIds, exportCompanyCountryIds} = res.data
          countryIds = countryIds|| []
          destinationCountryIds = destinationCountryIds||[]
          importerCompanyNames = importerCompanyNames || []
          hsCods = hsCods|| []
          productDescriptions = productDescriptions||[]
          exporterCompanyNames = exporterCompanyNames|| []
          originCountryIds = originCountryIds||[]
          exportCompanyCountryIds = exportCompanyCountryIds || []
          importCompanyCountryIds = importCompanyCountryIds||[]

          // this.params.autoTranslate = false
          if (this.datalist.moreType == 1) {
            this.params.countryIds = countryIds.length > 0 ? countryIds : destinationCountryIds.length > 0 ? destinationCountryIds : importCompanyCountryIds
          } else if (this.datalist.moreType == 2) {
            this.params.countryIds = countryIds.length > 0 ? countryIds : originCountryIds.length > 0 ? originCountryIds : exportCompanyCountryIds
          }
          if (this.params.countryIds.length==0) {
            this.params.countryIds = [0]
          }
          hsCods = hsCods.map(e => ({type: 'or', value: e}))
          importerCompanyNames = importerCompanyNames.map(e => ({type: 'or', value: e}))
          exporterCompanyNames = exporterCompanyNames.map(e => ({type: 'or', value: e}))
          productDescriptions = productDescriptions.map(e => ({type: 'or', value: e.currentValue, trans: [...e.data]}))
          
          this.$set(this.params, 'hsCodes', hsCods)
          this.$set(this.params, 'buyerCompanys', importerCompanyNames)
          this.$set(this.params, 'supplierCompanys', exporterCompanyNames)
          this.$set(this.params, 'productDescriptions', productDescriptions)

          this.$nextTick(()=>{
            this.$refs['smartBusisnessDialog'].open(this.params)
          });
        }
      })
    },
    closeBusisness(){

    },
    gotoTrade() {
      const tradeType= `tabCheck=3&uniqueKey=${this.datalist.uniqueKey}&defaultSort=tradeAmount`;
      window.open(`${this.localhost}/trade/result?${tradeType}&wlf=ai_gpt`, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .row-nowrap, .companyNameLink {
  white-space: nowrap;
}
.list-wrap {
  .list-item {
    display: flex;
    .clickCompany {
      color: $--color-link;
    }
  }
  .el-button {
    margin-top: 8px;
    border-radius: 6px;
    &:hover, &:focus {
      color: $--color-link;
      border: 1px solid $--color-link;
    }
  }
  .checkMore {
    margin-right: 10px;
    /deep/ .el-button--primary {
      background: $--color-border;
      color: $--color-black;
      background-color: $--color-white;
      border-color: $--color-border;
      &:hover {
        border-color: $--color-link !important;
      }
      &:first-child {
        margin-left: 0;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      &:last-child {
        border-left: 1px solid $--color-border;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }
    .dropdown-menu {
      padding-left: 0 !important;
      .el-dropdown-menu__item {
        width: 73px;
        &:hover {
          color: $--color-black;
          background: #eaecee;
        }
      }
    }
  }
  /deep/ .table {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px
  }
}
</style>
